var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: { centered: "", "hide-header-close": "" },
          on: { show: _vm.load },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "base-button",
                    {
                      attrs: { variant: "primary", disabled: !_vm.value },
                      on: {
                        click: function($event) {
                          return _vm.changeUser(_vm.patientId)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("menu.change-user")))]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.isVisible,
            callback: function($$v) {
              _vm.isVisible = $$v
            },
            expression: "isVisible"
          }
        },
        [
          _c("base-select", {
            attrs: {
              options: _vm.patients,
              valueProp: "id",
              placeholder: _vm.$t("menu.change-user-placeholder"),
              label: "fullName",
              loading: _vm.loading
            },
            model: {
              value: _vm.patientId,
              callback: function($$v) {
                _vm.patientId = $$v
              },
              expression: "patientId"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { else: "", centered: "", "hide-header-close": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "base-button",
                    {
                      attrs: { variant: "primary", disabled: !_vm.value },
                      on: { click: _vm.createAssociatedPatient }
                    },
                    [_vm._v(_vm._s(_vm.$t("menu.change-user-create")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-alert", { attrs: { variant: "info" } }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("menu.change-user-no-patients")) +
                "\n\t\t"
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a3f0df6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3f0df6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/ChangeUserModal.vue
// module id = 2046
// module chunks = 117